const minutesToHours = minutes => {
  let hour = Math.floor(minutes / 60);
  let min = minutes % 60;

  hour = hour !== 0 ? (hour = `${hour} hr`) : (hour = '');
  min = min !== 0 ? (min = `${min} min`) : (min = '');

  return `${hour} ${min}`;
};

export default minutesToHours;
